import handleResponse from './request/handleProfileResponse'

export default function(api: GlobalFetch) {
  return async function(files: any, calendarId: number) {
    const formData = new FormData()

    formData.append('file', files[0])

    const response = await api.fetch(
      `/api/v2/object/logo/id_calendar/${calendarId}`,
      {
        body: formData,
        method: 'POST',
      },
    )
    return await handleResponse(response)
  }
}

export interface IRequestValues {
  file: string
}
